import { __assign, __awaiter, __generator } from "tslib";
import { debug } from 'shared/utils/debug';
import { pathOr } from 'shared/utils/misc';
import { replaceUrlMacros } from './urlMacros';
/**
 * Fetch multiple feed responses
 */
export var fetchFeedUrls = function (feedUrls) { return __awaiter(void 0, void 0, void 0, function () {
    var responses;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                responses = {};
                return [4 /*yield*/, Promise.all(feedUrls.map(function (feedUrl) { return __awaiter(void 0, void 0, void 0, function () {
                        var id, url, processedUrl, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    id = feedUrl.id, url = feedUrl.url;
                                    processedUrl = replaceUrlMacros(url);
                                    return [4 /*yield*/, fetchUrl(processedUrl)];
                                case 1:
                                    response = _a.sent();
                                    // excludes empty response
                                    if (!response) {
                                        debug("Unable to fetch: " + url);
                                        return [2 /*return*/];
                                    }
                                    responses[id] = response;
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/, responses];
        }
    });
}); };
/**
 * Fetch a single url
 */
export var fetchUrl = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!url) {
                    return [2 /*return*/, undefined];
                }
                return [4 /*yield*/, fetchGet(url)
                        .then(function (r) {
                        if (!r.ok) {
                            throw new Error();
                        }
                        return r.json();
                    })
                        .catch(function () {
                        return undefined;
                    })];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, resp];
        }
    });
}); };
/**
 * Replace a primitive value in an nested object or array.
 * -Is the same as Ramda's `set(lensPath(path), value, object)`
 */
export var replaceValueInObject = function (path) {
    if (path === void 0) { path = []; }
    return function (obj, value) {
        var _a;
        var currentKey = path[0];
        // empty path, process no further
        if (currentKey === undefined) {
            return obj;
        }
        var node = obj[currentKey];
        // check if it's the end of node. `object` includes array
        var isNodeEnd = typeof node !== 'object';
        // go to next level of the object
        var nextPath = path.slice(1);
        return __assign(__assign({}, obj), (_a = {}, _a[currentKey] = isNodeEnd
            ? value
            : replaceValueInObject(nextPath)(node, value), _a));
    };
};
/**
 * Access string value of the object path
 * - For value is object or array, it will return `undefined`
 */
export var accessValueString = function (obj, path) {
    if (!obj || !path || path.length === 0) {
        return;
    }
    // const value = path.reduce((carrier, node) => carrier[node], obj);
    var value = pathOr('', path, obj);
    if (typeof value === 'object') {
        return;
    }
    return "" + value;
};
/**
 * Extreme light fetch get with trimmed down Response.
 */
var fetchGet = function (url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('get', url, true);
        var response = function () {
            return ({
                // Ok status: 200-299
                ok: xhr.status >= 200 && xhr.status < 300,
                json: function () { return Promise.resolve(xhr.responseText).then(JSON.parse); },
            });
        };
        xhr.onload = function () {
            resolve(response());
        };
        xhr.onerror = reject;
        xhr.send(null);
    });
};
